<ion-row class="footer-row ion-justify-content-between">
  @if (!edit) {
    <ion-button
      class="back-btn"
      id="button-text"
      fill="outline"
      (click)="cancel()"
      onKeyDown="cancel()"
    >
      {{ CONSTANTS.CANCEL }}
    </ion-button>
  }
  @if (edit) {
    <ion-button
      class="back-btn"
      id="button-text"
      [disabled]="!resetBtnEnabled"
      fill="outline"
      (click)="reset()"
      onKeyDown="reset()"
      tabindex="0"
    >
      {{ CONSTANTS.RESET }}
    </ion-button>
  }
  <ion-button
    class="next-btn"
    id="button-text"
    [disabled]="!btnEnabled"
    (click)="submitBtnClick.emit()"
    onKeyDown="submitBtnClick.emit()"
  >
    @if (!edit) {
      {{ btnText }}
    }
    @if (edit) {
      {{ CONSTANTS.SAVE }}
    }
  </ion-button>
</ion-row>
